import { useQueryClient } from '@tanstack/react-query'
import { IUseSignOut } from 'api/types/auth'
import { QUERY_KEY } from 'app/constants'
import { pageConfig } from 'app/page-config'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export const useSignOut = (): IUseSignOut => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const onSignOut = useCallback(() => {
    queryClient.setQueryData([QUERY_KEY.user], null)
    navigate(pageConfig.auth)
  }, [navigate, queryClient])

  return onSignOut
}
